let languageList = ["EN", "GU", "FR", "AR"];
let paginationOptions = [10, 25, 50, 100];
let entityTypeList = [
  {
    value: 1,
    label: "Packing",
  },
  {
    value: 2,
    label: "Retailer",
  },
];

const config = {
  API_URL: process.env.REACT_APP_API_URL_LOCAL,
  IS_DEV: process.env.REACT_APP_ENV === "development",
  IS_PRODUCT: process.env.REACT_APP_ENV === "production",
  DECRYPT_KEY: "r5u8x/A?D(G+KbPeShVmYq3s6v9y$C&E",
  DECRYPT_IV: "5fgf5HJ5g2752158",
  IS_JSON: false,
  MAX_IMAGE_SIZE: 10 * 1024 * 1024, //10 MB
  MAX_VIDEO_SIZE: 100 * 1024 * 1024, //100 MB
  LANGUAGE_LIST: languageList,
  PAGINATION_OPTIONS: paginationOptions,
  login_data: "@secure.@data",
  dataTableLength: [10, 25, 75, 100],
  ROLE_ADMIN: 1,
  ROLE_OWNER: 2,
  ROLE_CUSTOMER: 3,
  ENTITY_TYPE_LIST: entityTypeList,
  DATA_LIMIT:20,
  GOOGLE_KEY:"AIzaSyDYWYqF3OA-U8hJpDyYqojI_bbCYwvPFqw",
  config_data: "configData",

};

export default config;
